import { render, staticRenderFns } from "./GroupPermissionsTab.vue?vue&type=template&id=1b7a6400"
import script from "./GroupPermissionsTab.vue?vue&type=script&lang=js"
export * from "./GroupPermissionsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports